import { NgModule } from '@angular/core';

import { ButtonGroupComponent } from './button-group.component';
export { ButtonGroupComponent } from './button-group.component';

@NgModule({
  imports: [ButtonGroupComponent],
  exports: [ButtonGroupComponent],
})
export class GalaxyButtonGroupModule {}
